import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../messages";
import toastr from "toastr";
import NotificationsServices from "./notifications.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotifications = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATIONS,
      payload: true,
    });
    const resp = await NotificationsServices.getNotifications(filters);
    dispatch({
      type: actions.GET_NOTIFICATIONS,
      payload: resp.data,
    });
    dispatch({
      type: actions.NOTIFICATIONS_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 401:
            window.location.href = "/";
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.NOTIFICATIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATIONS,
      payload: false,
    });
  }
};

export const notificationsRead = (id, dataT, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_NOTIFICATIONS,
      payload: true,
    });
    await NotificationsServices.notificacionRead(id, dataT);
    const { data, count } = getState().notifications.notifications;
    // const {  notifications } = getState().notifications;
    let _data = data.slice();
    _data[index].leido = true;
    dispatch({
      type: actions.GET_NOTIFICATIONS,
      payload: {data:_data,count:count},
    });
    {
      /*  dispatch({
      type: actions.NOTIFICATIONS_FAIL,
      payload: "",
    }); */
    }
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_NOTIFICATIONS,
      payload: false,
    });
  }
};

export const saveNotifications = (req, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATIONS,
        payload: true,
      });
      const resp = await NotificationsServices.saveNotifications(req);
      const { data, count } = getState().notifications.notifications;
      dispatch({
        type: actions.GET_NOTIFICATIONS,
        payload: {
          count: count + 1,
          data: [...data, resp.data],
        },
      });
      dispatch({
        type: actions.FORM_NOTIFICATIONS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              if (ex.response.data && ex.response.data.detail) {
                message = ex.response.data.detail;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_NOTIFICATIONS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATIONS,
        payload: false,
      });
    }
  };

export const editNotifications = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATIONS,
        payload: true,
      });
      const resp = await NotificationsServices.editNotifications(req.id, req);
      const { data, count } = getState().notifications.notifications;
      let _data = data.slice();
      _data[index] = resp.data;
      dispatch({
        type: actions.GET_NOTIFICATIONS,
        payload: {
          data: _data,
          count: count,
        },
      });
      dispatch({
        type: actions.FORM_NOTIFICATIONS_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = ex.response.data[0];
              }
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_NOTIFICATIONS_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_NOTIFICATIONS,
        payload: false,
      });
    }
  };

export const deleteNotification = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATIONS,
      payload: true,
    });
    await NotificationsServices.deleteNotifications(id);
    const { data, count } = getState().notifications.notifications;
    let _data = data.slice();
    _data.splice(index, 1);
    dispatch({
      type: actions.GET_NOTIFICATIONS,
      payload: {
        data: _data,
        count: count - 1,
      },
    });
    dispatch({
      type: actions.FORM_NOTIFICATIONS_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FORM_NOTIFICATIONS_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATIONS,
      payload: false,
    });
  }
};
